import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { API } from '@/api'
import { Button, Input, message, Modal, Trans } from '@/components'
import { NetGroup } from '@/models/instance'
interface NetworkGroupEditModalProps {
  network: NetGroup
  onSuccess: (network: NetGroup) => void
  onClose: () => void
}

export function NetworkGroupEditModal({
  network,
  onSuccess = () => {},
  onClose = () => {},
}: NetworkGroupEditModalProps) {
  const [loading, setLoading] = useState(false)
  const [name, setName] = useState(network?.networkName ?? '')
  const { t } = useTranslation()
  const onOK = () => {
    setLoading(true)
    API.updateMesh({
      res_id: network.netResID,
      name: name,
    })
      .then((res) => {
        if (res.code === 0) {
          message.success(t('common.message.success'))
          onSuccess({ ...network, networkName: name })
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <Modal
      className="w-[640px]"
      open={true}
      onClose={() => {
        if (!loading) {
          onClose()
        }
      }}
    >
      <Modal.Header>
        {network ? (
          <Trans i18nKey="mesh.networkGroupEditModal.editTitle" />
        ) : (
          <Trans i18nKey="mesh.networkGroupEditModal.createTitle" />
        )}
      </Modal.Header>
      <Modal.Body>
        <div className="flex-row ">
          <div className="w-full t-lg text-primary">
            <div className="mb-2 text-with-star">
              <Trans i18nKey="mesh.networkGroupEditModal.form.name">Name</Trans>
            </div>
            <div className="w-full t-lg text-primary mb-2">
              <Input
                placeholder={t('mesh.networkGroupEditModal.form.namePlaceholder')}
                value={name}
                disabled={loading}
                maxLength={30}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="outline"
          onClick={() => {
            if (!loading) {
              onClose()
            }
          }}
        >
          <Trans i18nKey="common.confirmModalCancel">Cancel</Trans>
        </Button>
        <Button
          type="secondary"
          disabled={loading || name?.length <= 0 || name === network?.networkName}
          onClick={onOK}
        >
          {network ? (
            <Trans i18nKey="common.confirmModalConfirm">Confirm</Trans>
          ) : (
            <Trans i18nKey="common.confirmModalCreate">Create</Trans>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
